interface KeyPointsBoxProps {
  title: string;
  points: string[];
}

/**
 * 要点ボックス。◆ 箇条書きで記事の要点を差し込む。紙色地＋金の左罫。
 */
export default function KeyPointsBox({ title, points }: KeyPointsBoxProps) {
  return (
    <aside className="bg-[#f8f6f0] border border-[#e2ddd2] border-l-4 border-l-[#a38e65] p-7 sm:p-8">
      <span className="block font-['Playfair_Display',serif] uppercase tracking-[0.22em] text-[11px] text-[#8f7a56] mb-2">Key Points</span>
      <h3 className="jba-display font-medium text-[#1a2942] text-lg sm:text-xl mb-5">{title}</h3>
      <ul className="space-y-3.5">
        {points.map((p, i) => (
          <li key={i} className="flex gap-3 text-[#333] text-[15px] sm:text-base leading-[1.85] font-['Noto_Serif_JP',serif]">
            <span aria-hidden="true" className="text-[#a38e65] shrink-0 mt-[2px]">&#9670;</span>
            <span className="min-w-0">{p}</span>
          </li>
        ))}
      </ul>
    </aside>
  );
}
